// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  /* background: #f0f0f0; */
  scroll-behavior: smooth;
  /* font-family: "Roboto", sans-serif; */
}
body {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
.container {
  position: relative;
  top: 5rem;
  /* margin-top: 7rem; */
  margin-bottom: 1rem;
  padding-bottom: 2rem;
  /* min-height: 100vh; */
  position: relative;
  min-width: 95vw;
}
.notification {
  position: absolute !important;
  display: inline-block;
  /* right: 0;
  top: -4.5vh; */
  top: -8.5vh;
  left: 35%;
  min-width: 30%;
  animation: move 2s;
  animation-direction: normal;
  animation-iteration-count: 1;
  z-index: 9999;
}
@keyframes move {
  0% {
    transform: translateY(-103%);
  }
  100% {
    transform: translateY(0);
  }
}
.container > .modal {
  z-index: 9998;
}
.loginSection {
  margin: 1rem auto;
}
.loginSection > .box {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
}
.loginSection > .box > .logoContainer {
  display: flex;
  flex-wrap: wrap;
}
.loginSection
  > .box
  > .logoContainer
  > .swiper
  > .swiper-wrapper
  > .swiper-slide
  > .image {
  width: 100%;
  height: 10rem;
}
.loginSection
  > .box
  > .logoContainer
  > .swiper
  > .swiper-wrapper
  > .swiper-slide
  > .image
  > img {
  width: 50%;
  height: 100%;
  object-fit: contain;
}
.loginSection > .box > .logoContainer > .swiper > .swiper-button-prev {
  display: none;
}
.loginSection > .box > .logoContainer > .swiper > .swiper-button-next {
  display: none;
}
.loginSection > .box > .logoContainer > .image {
  flex: 1 0 21%;
}
.loginSection > .box > .logoContainer > .image > img {
  height: 100%;
  width: 100%;
  object-fit: contain;
}
.loginSection > .box > form {
  width: 20%;
}
.loginSection > .box > div {
  width: 75%;
}
.accountSection {
  margin: 1rem auto;
}
.accountSection > .box > .addUserForm {
  width: 100%;
}
.accountSection > .box > .addUserForm > .userForm {
  width: 45%;
}
.accountSection > .box > .addUserForm > .generatePass {
  width: 45%;
}
.accountSection > .box > div > form {
  width: 45%;
}
.accountSection > .box > .searchBarAcc > .searchSub {
  width: 100%;
}
.accountSection > .box > .resultsDiv > div {
  border-bottom: 1px solid #d6d9e0;
  width: 100%;
}
.accountSection > .box > .resultsDiv > .table {
  font-size: 0.75rem;
}
.accountSection > .box > .resultsDiv > .table > tbody {
  cursor: pointer;
}
.accountSection > .box:nth-child(2) {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.accountSection > .box:nth-child(3) > .table > tbody > tr {
  cursor: pointer;
}
.accountSection > .box > .account > h3 {
  text-align: center;
}
.accountSection > .box > .table > thead > tr > th svg {
  cursor: pointer;
  margin-left: 0.5rem;
}
.accountSection > .box > .topTitle {
  border-bottom: 1px solid #d6d9e0;
}
.accountSection > .box > .topTitle > .subtitle {
  width: 30%;
}
.playerSection {
  margin: 1rem auto;
}
.playerSection > .box > .addPlayerTop {
  border-bottom: 1px solid #d6d9e0;
}
.playerSection > .box > .addPlayerTop > div {
  width: 30%;
}
.playerSection > .box > .addPlayerTop > .buttons {
  width: 70%;
}
.playerSection > .box > .box > .table > tbody > tr > .possibleOwner > p > span {
  color: #7373f2;
}
.playerSection > .box > .box > .table > tbody > tr > .possibleOwner > p {
  display: flex;
}
.playerSection > .box > .box > .table > tbody > tr > .possibleOwner > p > span {
  margin-left: 1rem;
}
.playerSection > .box > .box > .table {
  font-size: small;
}
.playerSection
  > .box
  > .box
  > .table
  > tbody
  > tr
  > td
  > .buttons
  > .control
  > .button {
  padding: 0.2rem 1rem;
}
.playerSection > .box > .box > .table > tbody > tr > td > .buttons {
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: 0;
}
.playerSection > .box > .box > .table > tbody > tr > td:nth-last-child(1) {
  width: 9rem;
  padding: 0.2rem;
}
.playerSection > .box > .box > .rosterTable > tbody > tr {
  cursor: pointer;
}
.modal
  > .modal-content
  > .box
  > .media
  > .media-content
  > .content
  > .box
  > .field
  > .checkboxes {
  display: flex;
  flex-direction: column;
}
.modal
  > .modal-content
  > .box
  > .media
  > .media-content
  > .content
  > .box
  > .field
  > .checkboxes
  > .checkbox
  > input {
  margin-right: 1rem;
}
/* .playerSection > .addplayer {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  width: 100%;
  height: 40rem;
} */
.generalInfoAcc {
  width: 100%;
  border-bottom: 1px solid #d6d9e0;
}
.generalInfoAcc > .genInfoSubtitle {
  width: 100%;
}
.playerSection > .addplayerBox {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.seasonBox > form > .field > .control > div > div > div:nth-child(1) {
  font-size: 12px;
}
.seasonBox > form > .field > .control > div > div > div:nth-child(2) {
  height: 30px;
}
.seasonBox
  > form
  > .field
  > .releaseLoanContent
  > div
  > div
  > div:nth-child(1) {
  font-size: 12px;
}
.seasonBox
  > form
  > .field
  > .releaseLoanContent
  > div
  > div
  > div:nth-child(2) {
  height: 30px;
}
.updateSeasonBox > form > .field > .control > div > div > div:nth-child(1) {
  font-size: 12px;
}
.updateSeasonBox > form > .field > .control > div > div > div:nth-child(2) {
  height: 30px;
}
.addFiles
  > .media
  > .media-content
  > .content
  > form
  > .field
  > .field-body
  > .field
  > .control
  > div
  > div
  > div:nth-child(1) {
  font-size: 12px;
}
.addFiles
  > .media
  > .media-content
  > .content
  > form
  > .field
  > .field-body
  > .field
  > .control
  > div
  > div
  > div:nth-child(2) {
  height: 30px;
}
.playerSection
  > .addplayerBox
  > .addplayer
  .field:nth-child(4)
  > .field-body
  > .field
  > .control
  > div
  > div
  > div:nth-child(1) {
  font-size: 12px;
}
.playerSection
  > .addplayerBox
  > .addplayer
  .field:nth-child(4)
  > .field-body
  > .field
  > .control
  > div
  > div
  > div:nth-child(2) {
  height: 30px;
}
.playerSection
  > .addplayerBox
  > .addplayer
  .field:nth-child(6)
  > .field-body
  > .field
  > .control
  > div
  > div
  > div:nth-child(1) {
  font-size: 12px;
}
.playerSection
  > .addplayerBox
  > .addplayer
  .field:nth-child(6)
  > .field-body
  > .field
  > .control
  > div
  > div
  > div:nth-child(2) {
  height: 30px;
}
.playerSection
  > .addplayerBox
  > .addplayer
  .field:nth-child(8)
  > .field-body
  > .field
  > .control
  > div
  > div
  > div:nth-child(1) {
  font-size: 12px;
}
.playerSection
  > .addplayerBox
  > .addplayer
  .field:nth-child(8)
  > .field-body
  > .field
  > .control
  > div
  > div
  > div:nth-child(2) {
  height: 30px;
}
.playerSection
  > .addplayerBox
  > .addplayer
  .field:nth-child(10)
  > .field-body
  > .field
  > .control
  > div
  > div
  > div:nth-child(1) {
  font-size: 12px;
}
.playerSection
  > .addplayerBox
  > .addplayer
  .field:nth-child(10)
  > .field-body
  > .field
  > .control
  > div
  > div
  > div:nth-child(2) {
  height: 30px;
}
.playerSection
  > .addplayerBox
  > .addplayer
  .field:nth-child(11)
  > .field-body
  > .field
  > .control
  > div
  > div
  > div:nth-child(1) {
  font-size: 12px;
}
.playerSection
  > .addplayerBox
  > .addplayer
  .field:nth-child(11)
  > .field-body
  > .field
  > .control
  > div
  > div
  > div:nth-child(2) {
  height: 30px;
}
.playerSection
  > .addplayerBox
  > .addplayer
  .field:nth-child(12)
  > .field-body
  > .field
  > .control
  > div
  > div
  > div:nth-child(1) {
  font-size: 12px;
}
.playerSection
  > .addplayerBox
  > .addplayer
  .field:nth-child(12)
  > .field-body
  > .field
  > .control
  > div
  > div
  > div:nth-child(2) {
  height: 30px;
}
.playerSection
  > .addplayerBox
  > .addplayer
  .field:nth-child(13)
  > .field-body
  > .field
  > .control
  > div
  > div
  > div:nth-child(1) {
  font-size: 12px;
}
.playerSection
  > .addplayerBox
  > .addplayer
  .field:nth-child(13)
  > .field-body
  > .field
  > .control
  > div
  > div
  > div:nth-child(2) {
  height: 30px;
}
.playerSection > .box > .searchTeamCont {
  min-height: 8rem;
}
.container
  > .playerSection
  > .box
  > div
  > .searchTeamForm
  > .field
  > .field-body
  > .field
  > .control
  > div
  > div
  > div:nth-child(1) {
  font-size: 12px;
}
.container
  > .playerSection
  > .box
  > div
  > .searchTeamForm
  > .field
  > .field-body
  > .field
  > .control
  > div
  > div
  > div:nth-child(2) {
  height: 30px;
}
.container
  > .searchedTeam
  > .table-container
  > div
  > form
  > .field
  > .field-body
  > .field
  > .control
  > div
  > div
  > div:nth-child(1) {
  font-size: 12px;
}
.container
  > .searchedTeam
  > .table-container
  > div
  > form
  > .field
  > .field-body
  > .field
  > .control
  > div
  > div
  > div:nth-child(2) {
  height: 30px;
}
.container
  > .searchedTeam
  > .table-container
  > .buttons
  > .paymentStatusbtn
  > .field
  > .control
  > div
  > div
  > div:nth-child(1) {
  font-size: 12px;
}
.container
  > .searchedTeam
  > .table-container
  > .buttons
  > .paymentStatusbtn
  > .field
  > .control
  > div
  > div
  > div:nth-child(2) {
  height: 30px;
}

.container > .searchedTeam > .table-container > .teamImgName > .image {
  width: 5rem;
  height: 5rem;
}
.container > .searchedTeam > .table-container > .teamImgName > .image > img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.container > .searchedTeam > .table-container > div > form {
  width: 40%;
}
.container > .searchedTeam > .table-container > div > .sameNewTeamFinal {
  width: 55%;
}
.container > .searchedTeam > .table-container > .table {
  font-size: 0.75rem !important;
  cursor: pointer;
}
.container > .playerSection > .box > div > .searchTeamForm {
  width: 50%;
}
.playerSection > .box > .addplayer {
  width: 50%;
}
.playerSection > .box > .addplayercard {
  width: 45%;
}
.playerSection > .box > .addplayer > .field {
  width: 100%;
}
.playerSection
  > .addplayer
  > .field
  > .field-body
  > .field
  > .control
  > .checkbox {
  height: 18px;
  width: 18px;
}
.playerSection > .addplayerBox > .addplayer > .field > .file > .file-label {
  width: 100%;
}
.playerSection > .addplayerBox > .addplayercard > .card-content > .media {
  border-bottom: 1px solid #d6d9e0;
}
/* .playerSection > .addplayer > .is-grouped {
  width: 100%;
  position: relative;
  bottom: 0;
} */
/* .mainSection {
  position: relative;
  width: 90%;
  height: 100%;
  margin: 8rem auto 2rem auto;
}
.mainSection > .player {
  margin-bottom: 2rem;
} */
.iconlinksinner2 > div > svg {
  height: 2rem;
}
.iconlinksinner > a > svg {
  height: 2rem;
}
.navbar-item {
  text-decoration: none;
  width: 10rem;
  border: 2px solid #7373f2;
  border-radius: 0.5rem;
  margin-right: 0.5rem;
}
.navbar-item:hover {
  background: #7373f2;
  box-shadow: 0.1rem 0.1rem 0 0 rgba(0, 0, 0, 1);
  color: #ffffff;
  transition: 0.3s;
}
.iconlinks {
  margin-top: 1rem;
  display: flex;
  justify-content: space-between;
  border: 1px solid #808080;
  border-radius: 0.5rem;
  padding: 0.5rem;
}
.iconlinksinner {
  display: flex;
  flex-direction: row;
}
.iconlinksinner > a {
  color: #7373f2;
  display: flex;
  align-items: center;
  flex-direction: column;
}
.iconlinksinner2 > div {
  color: #7373f2;
  display: flex;
  align-items: center;
  flex-direction: column;
}
.iconlinksinner2 > .navbar-item {
  margin-right: 0;
}
.searchBar {
  border-bottom: 1px solid #808080;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin: 2rem 0;
  padding-bottom: 2rem;
}
.searchBar > h3 {
  margin-top: 0;
  width: 100%;
}
.searchByTeam {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
}
.searchByTeam > h3 {
  margin-top: 0;
  width: 100%;
}
.searchByTeam > p {
  color: #808080;
  font-size: 0.75rem;
  width: 100%;
}
.tableplayerlength {
  color: #7373f2;
  text-align: center;
}
.topBox > div {
  width: 100%;
}
.topBox > div:nth-child(1) {
  border-bottom: 1px solid #d6d9e0;
}
.topBox > div > .playerName {
  width: 30%;
}
.topBox > div > .playerName > div {
  width: 90%;
  border: 1px solid #d6d9e0;
  padding: 0.4rem;
  border-radius: 0.3rem;
}
.topBox > div > .buttons {
  width: 70%;
}
.topBox > div > .searchTeam {
  width: 50%;
}
.topBoxSearchForms {
  width: 100%;
}
.topBoxSearchForms > div > form {
  width: 30%;
}
.topBoxSearchForms > .box > .table {
  font-size: 0.75rem !important;
}
.topBoxSearchForms > .box > .table > tbody {
  cursor: pointer;
}
.playerInfo {
  height: 40rem;
}
.playerInfo > div {
  width: 100%;
}
.playerInfo > div > .media {
  width: 30%;
}
.playerInfo > div > .articleandinfo {
  border-right: 1px solid #d6d9e0;
  margin-right: 1rem;
  width: 28%;
}
.playerInfo > div > .articleandinfo > .genInfo {
  width: 100%;
}
.playerInfo > div > .articleandinfo > .media {
  border-bottom: 1px solid #d6d9e0;
}
.playerInfo > div > .genInfo > .title {
  width: 100%;
}
.playerInfo > div > .genInfo > form > .buttons {
  width: 100%;
}
.playerInfo > div > .articleandinfo > .genInfo > form > .field {
  width: 47%;
}
.playerInfo > div > .articleandinfo > .genInfo > form > .textAreaField {
  width: 96%;
}
.playerInfo > div > .playerHistory {
  /* border-top: 1px solid #d6d9e0; */
  width: 70%;
}
.playerInfo > div > .playerHistory > div > .table-container > .table {
  font-size: 0.6rem;
}
.playerInfo > div > .playerHistory > div > .table-container {
  height: 25rem;
  overflow-y: scroll;
}
.playerInfo > div > .playerHistory > div > .table-container > table > thead {
  position: sticky;
  top: 0;
}
/* .playerInfo
  > div
  > .playerHistory
  > div
  > .table-container
  > .table
  > thead
  > tr
  > th:nth-child(1) {
  width: 5%;
}
.playerInfo
  > div
  > .playerHistory
  > div
  > .table-container
  > .table
  > thead
  > tr
  > th:nth-child(2) {
  width: 7%;
}
.playerInfo
  > div
  > .playerHistory
  > div
  > .table-container
  > .table
  > thead
  > tr
  > th:nth-child(3) {
  width: 17%;
}
.playerInfo
  > div
  > .playerHistory
  > div
  > .table-container
  > .table
  > thead
  > tr
  > th:nth-child(4) {
  width: 17%;
}
.playerInfo
  > div
  > .playerHistory
  > div
  > .table-container
  > .table
  > thead
  > tr
  > th:nth-child(5) {
  width: 20%;
}
.playerInfo
  > div
  > .playerHistory
  > div
  > .table-container
  > .table
  > thead
  > tr
  > th:nth-child(6) {
  width: 8%;
}
.playerInfo
  > div
  > .playerHistory
  > div
  > .table-container
  > .table
  > thead
  > tr
  > th:nth-child(7) {
  width: 8%;
}
.playerInfo
  > div
  > .playerHistory
  > div
  > .table-container
  > .table
  > thead
  > tr
  > th:nth-child(8) {
  width: 8%;
} */
/* .playerInfo
  > div
  > .playerHistory
  > div
  > .table-container
  > .table
  > tbody
  > tr
  > td {
  overflow-x: scroll;
} */

.playerInfo > div > .playerHistory > .currlastTeamRoster > .table-container {
  height: 25rem;
  overflow-y: scroll;
}
.playerInfo
  > div
  > .playerHistory
  > .currlastTeamRoster
  > .table-container
  > .table {
  font-size: 0.6rem;
}
.playerInfo
  > div
  > .playerHistory
  > .currlastTeamRoster
  > .table-container
  > .table
  > tbody {
  cursor: pointer;
}
.button > .icon {
  height: 12px !important;
  width: 12px !important;
}
.button > .icon > svg {
  height: 100% !important;
  width: 100% !important;
  object-fit: contain;
}
.mklusersBox {
  height: 40rem;
  width: 100%;
}
.mklusersBox > .usersBoxtop {
  width: 100%;
  border-bottom: 1px solid #d6d9e0;
}
.mklusersBox > .mklusersBoxUsers {
  width: 100%;
  height: 92%;
}
.mklusersBox > .mklusersBoxUsers > div {
  width: 40%;
  height: 100%;
  overflow: scroll;
}
.mklusersBox > .mklusersBoxUsers > .editUsers {
  width: 55%;
  height: 100%;
}
.mklusersBox > .mklusersBoxUsers > .editUsers > div > .generatePass {
  height: 20rem;
}
.mklusersBox > .mklusersBoxUsers > div > .table-container {
  height: 100%;
  overflow-y: scroll !important;
}
.mklusersBox
  > .mklusersBoxUsers
  > div
  > .table-container
  > .table
  > thead
  > tr
  > th {
  position: sticky !important;
  top: 0 !important;
  background-color: #d6d9e0 !important;
  z-index: 1 !important;
}
.mklusersBox
  > .mklusersBoxUsers
  > div
  > .table-container
  > .table
  > thead
  > tr
  > th:nth-child(1) {
  width: 20%;
  border-top-left-radius: 0.75rem;
  /* border-right: 1px solid #d6d9e0; */
}
.mklusersBox
  > .mklusersBoxUsers
  > div
  > .table-container
  > .table
  > thead
  > tr
  > th:nth-child(2) {
  width: 80%;
  border-top-right-radius: 0.75rem;
}
.mklusersBox > .mklusersBoxUsers > div > .table-container > .table > tbody {
  font-size: 0.85rem;
}
.mklusersBox
  > .mklusersBoxUsers
  > div
  > .table-container
  > .table
  > tbody
  > tr
  > td:nth-child(1) {
  border-right: 1px solid #d6d9e0;
}
.mklusersBox
  > .mklusersBoxUsers
  > div
  > .table-container
  > .table
  > tbody
  > tr {
  cursor: pointer;
}

@media screen and (min-width: 1024px) {
  .playerSection > .box:nth-child(3) > .box {
    width: 100%;
  }
  .playerSection > .box:nth-child(3) > .box > form {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    max-height: 30rem;
    width: 100%;
  }
  .playerSection > .box:nth-child(3) > .box > form > .field {
    width: 45%;
  }
  .playerSection > .box:nth-child(3) > .box > h3 {
    text-align: center;
  }
  .playerSection > .registerUser {
    width: 50%;
  }
}
@media screen and (min-width: 1201px) {
  .playerInfo > div > .playerHistory > div > .table-container > .table {
    font-size: 0.65rem;
  }
  .playerInfo
    > div
    > .playerHistory
    > .currlastTeamRoster
    > .table-container
    > .table {
    font-size: 0.65rem;
  }
  .playerInfo > div > .articleandinfo {
    width: 25%;
  }
  .playerInfo > div > .playerHistory {
    width: 73%;
  }
}
@media screen and (min-width: 1401px) {
  .playerInfo > div > .playerHistory > div > .table-container > .table {
    font-size: 0.75rem;
  }
  .playerInfo
    > div
    > .playerHistory
    > .currlastTeamRoster
    > .table-container
    > .table {
    font-size: 0.75rem;
  }
  .playerInfo > div > .articleandinfo {
    width: 23%;
  }
  .playerInfo > div > .playerHistory {
    width: 75%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,uCAAuC;AACzC;AACA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB;gBACc;EACd,WAAW;EACX,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,2BAA2B;EAC3B,4BAA4B;EAC5B,aAAa;AACf;AACA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,wBAAwB;EAC1B;AACF;AACA;EACE,aAAa;AACf;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,WAAW;AACb;AACA;EACE,aAAa;EACb,eAAe;AACjB;AACA;;;;;;;EAOE,WAAW;EACX,aAAa;AACf;AACA;;;;;;;;EAQE,UAAU;EACV,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,iBAAiB;AACnB;AACA;EACE,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,gCAAgC;EAChC,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,UAAU;AACZ;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;;;;;;;;;;EAUE,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,MAAM;AACR;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;;;;;;;;;EASE,aAAa;EACb,sBAAsB;AACxB;AACA;;;;;;;;;;;EAWE,kBAAkB;AACpB;AACA;;;;;;GAMG;AACH;EACE,WAAW;EACX,gCAAgC;AAClC;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;;;;;;;EAOE,eAAe;AACjB;AACA;;;;;;;EAOE,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;;;;;;;;;;;;EAYE,eAAe;AACjB;AACA;;;;;;;;;;;;EAYE,YAAY;AACd;AACA;;;;;;;;;;EAUE,eAAe;AACjB;AACA;;;;;;;;;;EAUE,YAAY;AACd;AACA;;;;;;;;;;EAUE,eAAe;AACjB;AACA;;;;;;;;;;EAUE,YAAY;AACd;AACA;;;;;;;;;;EAUE,eAAe;AACjB;AACA;;;;;;;;;;EAUE,YAAY;AACd;AACA;;;;;;;;;;EAUE,eAAe;AACjB;AACA;;;;;;;;;;EAUE,YAAY;AACd;AACA;;;;;;;;;;EAUE,eAAe;AACjB;AACA;;;;;;;;;;EAUE,YAAY;AACd;AACA;;;;;;;;;;EAUE,eAAe;AACjB;AACA;;;;;;;;;;EAUE,YAAY;AACd;AACA;;;;;;;;;;EAUE,eAAe;AACjB;AACA;;;;;;;;;;EAUE,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;;;;;;;;;;;;EAYE,eAAe;AACjB;AACA;;;;;;;;;;;;EAYE,YAAY;AACd;AACA;;;;;;;;;;;;EAYE,eAAe;AACjB;AACA;;;;;;;;;;;;EAYE,YAAY;AACd;AACA;;;;;;;;;;EAUE,eAAe;AACjB;AACA;;;;;;;;;;EAUE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,6BAA6B;EAC7B,eAAe;AACjB;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;;;;;;;EAOE,YAAY;EACZ,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,gCAAgC;AAClC;AACA;;;;GAIG;AACH;;;;;;;;GAQG;AACH;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,qBAAqB;EACrB,YAAY;EACZ,yBAAyB;EACzB,qBAAqB;EACrB,oBAAoB;AACtB;AACA;EACE,mBAAmB;EACnB,8CAA8C;EAC9C,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,eAAe;AACjB;AACA;EACE,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;AACA;EACE,aAAa;EACb,WAAW;AACb;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,gCAAgC;AAClC;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;EACV,yBAAyB;EACzB,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,gCAAgC;AAClC;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,mCAAmC;EACnC,UAAU;AACZ;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,MAAM;AACR;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAuFG;AACH;;;;;;;;;;GAUG;;AAEH;EACE,aAAa;EACb,kBAAkB;AACpB;AACA;;;;;;EAME,iBAAiB;AACnB;AACA;;;;;;;EAOE,eAAe;AACjB;AACA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,WAAW;AACb;AACA;EACE,WAAW;EACX,gCAAgC;AAClC;AACA;EACE,WAAW;EACX,WAAW;AACb;AACA;EACE,UAAU;EACV,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ,6BAA6B;AAC/B;AACA;;;;;;;;EAQE,2BAA2B;EAC3B,iBAAiB;EACjB,oCAAoC;EACpC,qBAAqB;AACvB;AACA;;;;;;;;EAQE,UAAU;EACV,+BAA+B;EAC/B,qCAAqC;AACvC;AACA;;;;;;;;EAQE,UAAU;EACV,gCAAgC;AAClC;AACA;EACE,kBAAkB;AACpB;AACA;;;;;;;;EAQE,+BAA+B;AACjC;AACA;;;;;;;EAOE,eAAe;AACjB;;AAEA;EACE;IACE,WAAW;EACb;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,iBAAiB;IACjB,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,kBAAkB;EACpB;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,kBAAkB;EACpB;EACA;;;;;;IAME,kBAAkB;EACpB;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,kBAAkB;EACpB;EACA;;;;;;IAME,kBAAkB;EACpB;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF","sourcesContent":["html {\n  /* background: #f0f0f0; */\n  scroll-behavior: smooth;\n  /* font-family: \"Roboto\", sans-serif; */\n}\nbody {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n.container {\n  position: relative;\n  top: 5rem;\n  /* margin-top: 7rem; */\n  margin-bottom: 1rem;\n  padding-bottom: 2rem;\n  /* min-height: 100vh; */\n  position: relative;\n  min-width: 95vw;\n}\n.notification {\n  position: absolute !important;\n  display: inline-block;\n  /* right: 0;\n  top: -4.5vh; */\n  top: -8.5vh;\n  left: 35%;\n  min-width: 30%;\n  animation: move 2s;\n  animation-direction: normal;\n  animation-iteration-count: 1;\n  z-index: 9999;\n}\n@keyframes move {\n  0% {\n    transform: translateY(-103%);\n  }\n  100% {\n    transform: translateY(0);\n  }\n}\n.container > .modal {\n  z-index: 9998;\n}\n.loginSection {\n  margin: 1rem auto;\n}\n.loginSection > .box {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  width: 100%;\n}\n.loginSection > .box > .logoContainer {\n  display: flex;\n  flex-wrap: wrap;\n}\n.loginSection\n  > .box\n  > .logoContainer\n  > .swiper\n  > .swiper-wrapper\n  > .swiper-slide\n  > .image {\n  width: 100%;\n  height: 10rem;\n}\n.loginSection\n  > .box\n  > .logoContainer\n  > .swiper\n  > .swiper-wrapper\n  > .swiper-slide\n  > .image\n  > img {\n  width: 50%;\n  height: 100%;\n  object-fit: contain;\n}\n.loginSection > .box > .logoContainer > .swiper > .swiper-button-prev {\n  display: none;\n}\n.loginSection > .box > .logoContainer > .swiper > .swiper-button-next {\n  display: none;\n}\n.loginSection > .box > .logoContainer > .image {\n  flex: 1 0 21%;\n}\n.loginSection > .box > .logoContainer > .image > img {\n  height: 100%;\n  width: 100%;\n  object-fit: contain;\n}\n.loginSection > .box > form {\n  width: 20%;\n}\n.loginSection > .box > div {\n  width: 75%;\n}\n.accountSection {\n  margin: 1rem auto;\n}\n.accountSection > .box > .addUserForm {\n  width: 100%;\n}\n.accountSection > .box > .addUserForm > .userForm {\n  width: 45%;\n}\n.accountSection > .box > .addUserForm > .generatePass {\n  width: 45%;\n}\n.accountSection > .box > div > form {\n  width: 45%;\n}\n.accountSection > .box > .searchBarAcc > .searchSub {\n  width: 100%;\n}\n.accountSection > .box > .resultsDiv > div {\n  border-bottom: 1px solid #d6d9e0;\n  width: 100%;\n}\n.accountSection > .box > .resultsDiv > .table {\n  font-size: 0.75rem;\n}\n.accountSection > .box > .resultsDiv > .table > tbody {\n  cursor: pointer;\n}\n.accountSection > .box:nth-child(2) {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n}\n.accountSection > .box:nth-child(3) > .table > tbody > tr {\n  cursor: pointer;\n}\n.accountSection > .box > .account > h3 {\n  text-align: center;\n}\n.accountSection > .box > .table > thead > tr > th svg {\n  cursor: pointer;\n  margin-left: 0.5rem;\n}\n.accountSection > .box > .topTitle {\n  border-bottom: 1px solid #d6d9e0;\n}\n.accountSection > .box > .topTitle > .subtitle {\n  width: 30%;\n}\n.playerSection {\n  margin: 1rem auto;\n}\n.playerSection > .box > .addPlayerTop {\n  border-bottom: 1px solid #d6d9e0;\n}\n.playerSection > .box > .addPlayerTop > div {\n  width: 30%;\n}\n.playerSection > .box > .addPlayerTop > .buttons {\n  width: 70%;\n}\n.playerSection > .box > .box > .table > tbody > tr > .possibleOwner > p > span {\n  color: #7373f2;\n}\n.playerSection > .box > .box > .table > tbody > tr > .possibleOwner > p {\n  display: flex;\n}\n.playerSection > .box > .box > .table > tbody > tr > .possibleOwner > p > span {\n  margin-left: 1rem;\n}\n.playerSection > .box > .box > .table {\n  font-size: small;\n}\n.playerSection\n  > .box\n  > .box\n  > .table\n  > tbody\n  > tr\n  > td\n  > .buttons\n  > .control\n  > .button {\n  padding: 0.2rem 1rem;\n}\n.playerSection > .box > .box > .table > tbody > tr > td > .buttons {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  gap: 0;\n}\n.playerSection > .box > .box > .table > tbody > tr > td:nth-last-child(1) {\n  width: 9rem;\n  padding: 0.2rem;\n}\n.playerSection > .box > .box > .rosterTable > tbody > tr {\n  cursor: pointer;\n}\n.modal\n  > .modal-content\n  > .box\n  > .media\n  > .media-content\n  > .content\n  > .box\n  > .field\n  > .checkboxes {\n  display: flex;\n  flex-direction: column;\n}\n.modal\n  > .modal-content\n  > .box\n  > .media\n  > .media-content\n  > .content\n  > .box\n  > .field\n  > .checkboxes\n  > .checkbox\n  > input {\n  margin-right: 1rem;\n}\n/* .playerSection > .addplayer {\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n  width: 100%;\n  height: 40rem;\n} */\n.generalInfoAcc {\n  width: 100%;\n  border-bottom: 1px solid #d6d9e0;\n}\n.generalInfoAcc > .genInfoSubtitle {\n  width: 100%;\n}\n.playerSection > .addplayerBox {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n}\n.seasonBox > form > .field > .control > div > div > div:nth-child(1) {\n  font-size: 12px;\n}\n.seasonBox > form > .field > .control > div > div > div:nth-child(2) {\n  height: 30px;\n}\n.seasonBox\n  > form\n  > .field\n  > .releaseLoanContent\n  > div\n  > div\n  > div:nth-child(1) {\n  font-size: 12px;\n}\n.seasonBox\n  > form\n  > .field\n  > .releaseLoanContent\n  > div\n  > div\n  > div:nth-child(2) {\n  height: 30px;\n}\n.updateSeasonBox > form > .field > .control > div > div > div:nth-child(1) {\n  font-size: 12px;\n}\n.updateSeasonBox > form > .field > .control > div > div > div:nth-child(2) {\n  height: 30px;\n}\n.addFiles\n  > .media\n  > .media-content\n  > .content\n  > form\n  > .field\n  > .field-body\n  > .field\n  > .control\n  > div\n  > div\n  > div:nth-child(1) {\n  font-size: 12px;\n}\n.addFiles\n  > .media\n  > .media-content\n  > .content\n  > form\n  > .field\n  > .field-body\n  > .field\n  > .control\n  > div\n  > div\n  > div:nth-child(2) {\n  height: 30px;\n}\n.playerSection\n  > .addplayerBox\n  > .addplayer\n  .field:nth-child(4)\n  > .field-body\n  > .field\n  > .control\n  > div\n  > div\n  > div:nth-child(1) {\n  font-size: 12px;\n}\n.playerSection\n  > .addplayerBox\n  > .addplayer\n  .field:nth-child(4)\n  > .field-body\n  > .field\n  > .control\n  > div\n  > div\n  > div:nth-child(2) {\n  height: 30px;\n}\n.playerSection\n  > .addplayerBox\n  > .addplayer\n  .field:nth-child(6)\n  > .field-body\n  > .field\n  > .control\n  > div\n  > div\n  > div:nth-child(1) {\n  font-size: 12px;\n}\n.playerSection\n  > .addplayerBox\n  > .addplayer\n  .field:nth-child(6)\n  > .field-body\n  > .field\n  > .control\n  > div\n  > div\n  > div:nth-child(2) {\n  height: 30px;\n}\n.playerSection\n  > .addplayerBox\n  > .addplayer\n  .field:nth-child(8)\n  > .field-body\n  > .field\n  > .control\n  > div\n  > div\n  > div:nth-child(1) {\n  font-size: 12px;\n}\n.playerSection\n  > .addplayerBox\n  > .addplayer\n  .field:nth-child(8)\n  > .field-body\n  > .field\n  > .control\n  > div\n  > div\n  > div:nth-child(2) {\n  height: 30px;\n}\n.playerSection\n  > .addplayerBox\n  > .addplayer\n  .field:nth-child(10)\n  > .field-body\n  > .field\n  > .control\n  > div\n  > div\n  > div:nth-child(1) {\n  font-size: 12px;\n}\n.playerSection\n  > .addplayerBox\n  > .addplayer\n  .field:nth-child(10)\n  > .field-body\n  > .field\n  > .control\n  > div\n  > div\n  > div:nth-child(2) {\n  height: 30px;\n}\n.playerSection\n  > .addplayerBox\n  > .addplayer\n  .field:nth-child(11)\n  > .field-body\n  > .field\n  > .control\n  > div\n  > div\n  > div:nth-child(1) {\n  font-size: 12px;\n}\n.playerSection\n  > .addplayerBox\n  > .addplayer\n  .field:nth-child(11)\n  > .field-body\n  > .field\n  > .control\n  > div\n  > div\n  > div:nth-child(2) {\n  height: 30px;\n}\n.playerSection\n  > .addplayerBox\n  > .addplayer\n  .field:nth-child(12)\n  > .field-body\n  > .field\n  > .control\n  > div\n  > div\n  > div:nth-child(1) {\n  font-size: 12px;\n}\n.playerSection\n  > .addplayerBox\n  > .addplayer\n  .field:nth-child(12)\n  > .field-body\n  > .field\n  > .control\n  > div\n  > div\n  > div:nth-child(2) {\n  height: 30px;\n}\n.playerSection\n  > .addplayerBox\n  > .addplayer\n  .field:nth-child(13)\n  > .field-body\n  > .field\n  > .control\n  > div\n  > div\n  > div:nth-child(1) {\n  font-size: 12px;\n}\n.playerSection\n  > .addplayerBox\n  > .addplayer\n  .field:nth-child(13)\n  > .field-body\n  > .field\n  > .control\n  > div\n  > div\n  > div:nth-child(2) {\n  height: 30px;\n}\n.playerSection > .box > .searchTeamCont {\n  min-height: 8rem;\n}\n.container\n  > .playerSection\n  > .box\n  > div\n  > .searchTeamForm\n  > .field\n  > .field-body\n  > .field\n  > .control\n  > div\n  > div\n  > div:nth-child(1) {\n  font-size: 12px;\n}\n.container\n  > .playerSection\n  > .box\n  > div\n  > .searchTeamForm\n  > .field\n  > .field-body\n  > .field\n  > .control\n  > div\n  > div\n  > div:nth-child(2) {\n  height: 30px;\n}\n.container\n  > .searchedTeam\n  > .table-container\n  > div\n  > form\n  > .field\n  > .field-body\n  > .field\n  > .control\n  > div\n  > div\n  > div:nth-child(1) {\n  font-size: 12px;\n}\n.container\n  > .searchedTeam\n  > .table-container\n  > div\n  > form\n  > .field\n  > .field-body\n  > .field\n  > .control\n  > div\n  > div\n  > div:nth-child(2) {\n  height: 30px;\n}\n.container\n  > .searchedTeam\n  > .table-container\n  > .buttons\n  > .paymentStatusbtn\n  > .field\n  > .control\n  > div\n  > div\n  > div:nth-child(1) {\n  font-size: 12px;\n}\n.container\n  > .searchedTeam\n  > .table-container\n  > .buttons\n  > .paymentStatusbtn\n  > .field\n  > .control\n  > div\n  > div\n  > div:nth-child(2) {\n  height: 30px;\n}\n\n.container > .searchedTeam > .table-container > .teamImgName > .image {\n  width: 5rem;\n  height: 5rem;\n}\n.container > .searchedTeam > .table-container > .teamImgName > .image > img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n.container > .searchedTeam > .table-container > div > form {\n  width: 40%;\n}\n.container > .searchedTeam > .table-container > div > .sameNewTeamFinal {\n  width: 55%;\n}\n.container > .searchedTeam > .table-container > .table {\n  font-size: 0.75rem !important;\n  cursor: pointer;\n}\n.container > .playerSection > .box > div > .searchTeamForm {\n  width: 50%;\n}\n.playerSection > .box > .addplayer {\n  width: 50%;\n}\n.playerSection > .box > .addplayercard {\n  width: 45%;\n}\n.playerSection > .box > .addplayer > .field {\n  width: 100%;\n}\n.playerSection\n  > .addplayer\n  > .field\n  > .field-body\n  > .field\n  > .control\n  > .checkbox {\n  height: 18px;\n  width: 18px;\n}\n.playerSection > .addplayerBox > .addplayer > .field > .file > .file-label {\n  width: 100%;\n}\n.playerSection > .addplayerBox > .addplayercard > .card-content > .media {\n  border-bottom: 1px solid #d6d9e0;\n}\n/* .playerSection > .addplayer > .is-grouped {\n  width: 100%;\n  position: relative;\n  bottom: 0;\n} */\n/* .mainSection {\n  position: relative;\n  width: 90%;\n  height: 100%;\n  margin: 8rem auto 2rem auto;\n}\n.mainSection > .player {\n  margin-bottom: 2rem;\n} */\n.iconlinksinner2 > div > svg {\n  height: 2rem;\n}\n.iconlinksinner > a > svg {\n  height: 2rem;\n}\n.navbar-item {\n  text-decoration: none;\n  width: 10rem;\n  border: 2px solid #7373f2;\n  border-radius: 0.5rem;\n  margin-right: 0.5rem;\n}\n.navbar-item:hover {\n  background: #7373f2;\n  box-shadow: 0.1rem 0.1rem 0 0 rgba(0, 0, 0, 1);\n  color: #ffffff;\n  transition: 0.3s;\n}\n.iconlinks {\n  margin-top: 1rem;\n  display: flex;\n  justify-content: space-between;\n  border: 1px solid #808080;\n  border-radius: 0.5rem;\n  padding: 0.5rem;\n}\n.iconlinksinner {\n  display: flex;\n  flex-direction: row;\n}\n.iconlinksinner > a {\n  color: #7373f2;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n}\n.iconlinksinner2 > div {\n  color: #7373f2;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n}\n.iconlinksinner2 > .navbar-item {\n  margin-right: 0;\n}\n.searchBar {\n  border-bottom: 1px solid #808080;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  margin: 2rem 0;\n  padding-bottom: 2rem;\n}\n.searchBar > h3 {\n  margin-top: 0;\n  width: 100%;\n}\n.searchByTeam {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  width: 100%;\n}\n.searchByTeam > h3 {\n  margin-top: 0;\n  width: 100%;\n}\n.searchByTeam > p {\n  color: #808080;\n  font-size: 0.75rem;\n  width: 100%;\n}\n.tableplayerlength {\n  color: #7373f2;\n  text-align: center;\n}\n.topBox > div {\n  width: 100%;\n}\n.topBox > div:nth-child(1) {\n  border-bottom: 1px solid #d6d9e0;\n}\n.topBox > div > .playerName {\n  width: 30%;\n}\n.topBox > div > .playerName > div {\n  width: 90%;\n  border: 1px solid #d6d9e0;\n  padding: 0.4rem;\n  border-radius: 0.3rem;\n}\n.topBox > div > .buttons {\n  width: 70%;\n}\n.topBox > div > .searchTeam {\n  width: 50%;\n}\n.topBoxSearchForms {\n  width: 100%;\n}\n.topBoxSearchForms > div > form {\n  width: 30%;\n}\n.topBoxSearchForms > .box > .table {\n  font-size: 0.75rem !important;\n}\n.topBoxSearchForms > .box > .table > tbody {\n  cursor: pointer;\n}\n.playerInfo {\n  height: 40rem;\n}\n.playerInfo > div {\n  width: 100%;\n}\n.playerInfo > div > .media {\n  width: 30%;\n}\n.playerInfo > div > .articleandinfo {\n  border-right: 1px solid #d6d9e0;\n  margin-right: 1rem;\n  width: 28%;\n}\n.playerInfo > div > .articleandinfo > .genInfo {\n  width: 100%;\n}\n.playerInfo > div > .articleandinfo > .media {\n  border-bottom: 1px solid #d6d9e0;\n}\n.playerInfo > div > .genInfo > .title {\n  width: 100%;\n}\n.playerInfo > div > .genInfo > form > .buttons {\n  width: 100%;\n}\n.playerInfo > div > .articleandinfo > .genInfo > form > .field {\n  width: 47%;\n}\n.playerInfo > div > .articleandinfo > .genInfo > form > .textAreaField {\n  width: 96%;\n}\n.playerInfo > div > .playerHistory {\n  /* border-top: 1px solid #d6d9e0; */\n  width: 70%;\n}\n.playerInfo > div > .playerHistory > div > .table-container > .table {\n  font-size: 0.6rem;\n}\n.playerInfo > div > .playerHistory > div > .table-container {\n  height: 25rem;\n  overflow-y: scroll;\n}\n.playerInfo > div > .playerHistory > div > .table-container > table > thead {\n  position: sticky;\n  top: 0;\n}\n/* .playerInfo\n  > div\n  > .playerHistory\n  > div\n  > .table-container\n  > .table\n  > thead\n  > tr\n  > th:nth-child(1) {\n  width: 5%;\n}\n.playerInfo\n  > div\n  > .playerHistory\n  > div\n  > .table-container\n  > .table\n  > thead\n  > tr\n  > th:nth-child(2) {\n  width: 7%;\n}\n.playerInfo\n  > div\n  > .playerHistory\n  > div\n  > .table-container\n  > .table\n  > thead\n  > tr\n  > th:nth-child(3) {\n  width: 17%;\n}\n.playerInfo\n  > div\n  > .playerHistory\n  > div\n  > .table-container\n  > .table\n  > thead\n  > tr\n  > th:nth-child(4) {\n  width: 17%;\n}\n.playerInfo\n  > div\n  > .playerHistory\n  > div\n  > .table-container\n  > .table\n  > thead\n  > tr\n  > th:nth-child(5) {\n  width: 20%;\n}\n.playerInfo\n  > div\n  > .playerHistory\n  > div\n  > .table-container\n  > .table\n  > thead\n  > tr\n  > th:nth-child(6) {\n  width: 8%;\n}\n.playerInfo\n  > div\n  > .playerHistory\n  > div\n  > .table-container\n  > .table\n  > thead\n  > tr\n  > th:nth-child(7) {\n  width: 8%;\n}\n.playerInfo\n  > div\n  > .playerHistory\n  > div\n  > .table-container\n  > .table\n  > thead\n  > tr\n  > th:nth-child(8) {\n  width: 8%;\n} */\n/* .playerInfo\n  > div\n  > .playerHistory\n  > div\n  > .table-container\n  > .table\n  > tbody\n  > tr\n  > td {\n  overflow-x: scroll;\n} */\n\n.playerInfo > div > .playerHistory > .currlastTeamRoster > .table-container {\n  height: 25rem;\n  overflow-y: scroll;\n}\n.playerInfo\n  > div\n  > .playerHistory\n  > .currlastTeamRoster\n  > .table-container\n  > .table {\n  font-size: 0.6rem;\n}\n.playerInfo\n  > div\n  > .playerHistory\n  > .currlastTeamRoster\n  > .table-container\n  > .table\n  > tbody {\n  cursor: pointer;\n}\n.button > .icon {\n  height: 12px !important;\n  width: 12px !important;\n}\n.button > .icon > svg {\n  height: 100% !important;\n  width: 100% !important;\n  object-fit: contain;\n}\n.mklusersBox {\n  height: 40rem;\n  width: 100%;\n}\n.mklusersBox > .usersBoxtop {\n  width: 100%;\n  border-bottom: 1px solid #d6d9e0;\n}\n.mklusersBox > .mklusersBoxUsers {\n  width: 100%;\n  height: 92%;\n}\n.mklusersBox > .mklusersBoxUsers > div {\n  width: 40%;\n  height: 100%;\n  overflow: scroll;\n}\n.mklusersBox > .mklusersBoxUsers > .editUsers {\n  width: 55%;\n  height: 100%;\n}\n.mklusersBox > .mklusersBoxUsers > .editUsers > div > .generatePass {\n  height: 20rem;\n}\n.mklusersBox > .mklusersBoxUsers > div > .table-container {\n  height: 100%;\n  overflow-y: scroll !important;\n}\n.mklusersBox\n  > .mklusersBoxUsers\n  > div\n  > .table-container\n  > .table\n  > thead\n  > tr\n  > th {\n  position: sticky !important;\n  top: 0 !important;\n  background-color: #d6d9e0 !important;\n  z-index: 1 !important;\n}\n.mklusersBox\n  > .mklusersBoxUsers\n  > div\n  > .table-container\n  > .table\n  > thead\n  > tr\n  > th:nth-child(1) {\n  width: 20%;\n  border-top-left-radius: 0.75rem;\n  /* border-right: 1px solid #d6d9e0; */\n}\n.mklusersBox\n  > .mklusersBoxUsers\n  > div\n  > .table-container\n  > .table\n  > thead\n  > tr\n  > th:nth-child(2) {\n  width: 80%;\n  border-top-right-radius: 0.75rem;\n}\n.mklusersBox > .mklusersBoxUsers > div > .table-container > .table > tbody {\n  font-size: 0.85rem;\n}\n.mklusersBox\n  > .mklusersBoxUsers\n  > div\n  > .table-container\n  > .table\n  > tbody\n  > tr\n  > td:nth-child(1) {\n  border-right: 1px solid #d6d9e0;\n}\n.mklusersBox\n  > .mklusersBoxUsers\n  > div\n  > .table-container\n  > .table\n  > tbody\n  > tr {\n  cursor: pointer;\n}\n\n@media screen and (min-width: 1024px) {\n  .playerSection > .box:nth-child(3) > .box {\n    width: 100%;\n  }\n  .playerSection > .box:nth-child(3) > .box > form {\n    display: flex;\n    flex-direction: column;\n    flex-wrap: wrap;\n    max-height: 30rem;\n    width: 100%;\n  }\n  .playerSection > .box:nth-child(3) > .box > form > .field {\n    width: 45%;\n  }\n  .playerSection > .box:nth-child(3) > .box > h3 {\n    text-align: center;\n  }\n  .playerSection > .registerUser {\n    width: 50%;\n  }\n}\n@media screen and (min-width: 1201px) {\n  .playerInfo > div > .playerHistory > div > .table-container > .table {\n    font-size: 0.65rem;\n  }\n  .playerInfo\n    > div\n    > .playerHistory\n    > .currlastTeamRoster\n    > .table-container\n    > .table {\n    font-size: 0.65rem;\n  }\n  .playerInfo > div > .articleandinfo {\n    width: 25%;\n  }\n  .playerInfo > div > .playerHistory {\n    width: 73%;\n  }\n}\n@media screen and (min-width: 1401px) {\n  .playerInfo > div > .playerHistory > div > .table-container > .table {\n    font-size: 0.75rem;\n  }\n  .playerInfo\n    > div\n    > .playerHistory\n    > .currlastTeamRoster\n    > .table-container\n    > .table {\n    font-size: 0.75rem;\n  }\n  .playerInfo > div > .articleandinfo {\n    width: 23%;\n  }\n  .playerInfo > div > .playerHistory {\n    width: 75%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
